const addonButtons = document.querySelectorAll('.optionButton');
const mainProduct = document.querySelector('.totalCost').getAttribute('data-main-product-id');
const totalPricing = document.getElementById('price');
let totalCost = 0;
let selectedBundle = "";
function getAddonlist() {
  if (typeof Addonlist === 'undefined') {
    Addonlist = [];
  } else {
    Addonlist = JSON.parse(sessionStorage.getItem('addonlist'));
  }
  sessionStorage.setItem('addonlist', JSON.stringify(Addonlist));
  return Addonlist;
}
function addToTotal (addonPrice) {
  addonPrice = addonPrice / 100;
  totalCost = totalCost + addonPrice;
  return totalCost;
}
function removeFromTotal (addonPrice) {
  addonPrice = addonPrice / 100;
  totalCost = totalCost - addonPrice;
  return totalCost;
}
function addToAddonlist(productId) {
  Addonlist = getAddonlist();
  if (!Addonlist.includes(productId)) {  
    Addonlist.push(productId);
    sessionStorage.setItem('addonlist', JSON.stringify(Addonlist));
  }
}

function removeFromAddonList(productId) {
  Addonlist = getAddonlist();
  if (Addonlist.includes(productId)) {
  Addonlist = Addonlist.filter(item => item !== productId);
  sessionStorage.setItem('addonlist', JSON.stringify(Addonlist));
  }
}
function addToCart(Addonlist) {
  Addonlist = getAddonlist();
  let AddonCartlist = Addonlist;
  AddonCartlist.push(mainProduct);
  let formData = {'items': []};
  AddonCartlist.forEach((element) => formData['items'].push({'id':(element),'quantity':1}));
    fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(formData)
  })
  .then(response => {
    return response.json();
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
addonButtons.forEach(addonButton => {
  addonButton.addEventListener('click', function() {
    if (this.textContent && this.textContent.includes("+")) {
     productId = this.getAttribute('data-product-id');
     addonPrice = this.getAttribute('data-cost');
     addToAddonlist(productId);
     totalCost = addToTotal(addonPrice);
     console.log(totalCost);
     this.textContent = this.textContent.replace(/\+/g, "-");
     addonButton.style.backgroundColor = 'black';
     addonButton.style.color = 'white';
     totalPricing.innerHTML = Number(totalCost);
          } else {
            this.textContent = this.textContent.replace(/\-/g, "+");
            addonButton.style.backgroundColor = 'white';
            addonButton.style.color = 'black';
            productId = this.getAttribute('data-product-id');
            addonPrice = this.getAttribute('data-cost');
            removeFromAddonList(productId);
            totalCost = removeFromTotal(addonPrice);
            totalPricing.innerHTML = Number(totalCost);
          }
     });
   });